import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

// import Tab from './tab';

class FormContent extends React.PureComponent {
    static propTypes = {};

    state = {
        index: 1,
    };

    // handleOnchange = index => {
    //     this.setState({
    //         index,
    //     });
    // };

    render() {
        const { index } = this.state;

        return (
            <div className={styles.formContent}>
                {/* <h2 className={styles.title}>注册凤凰通行证</h2> */}
                <div className={styles.box}>
                    <div className={styles.formList}>
                        <div className={styles.error}>系统繁忙，我们建议您：</div>
                        {/* <p className={styles.tip}>
                            您可以进入<a href="https://user.ifeng.com/my/info">用户中心</a> 或返回
                            <a href="https://www.ifeng.com">凤凰网首页</a>
                        </p> */}
                        <div className={styles.btn}>稍后重试</div>
                    </div>
                    <div className={styles.bot} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(FormContent);
